import React from 'react';
import { X, Package } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export const ScannedPiecesList = ({ pieces, onRemove }) => {
  const sourceCount = new Set(pieces.map((p) => p.old_bundle_code)).size;
  return (
    <section className="bg-white rounded-xl border border-[#E5DFD0] p-4" data-testid="fc-pieces-list">
      <div className="flex items-end justify-between mb-3">
        <div className="flex items-center gap-2">
          <Package className="h-4 w-4 text-[#2D5F4F]" />
          <h2 className="text-sm font-semibold text-[#1A1F2E]">Pieces in this bundle</h2>
        </div>
        <div className="text-right">
          <p className="text-3xl font-bold text-[#2D5F4F] leading-none" data-testid="fc-piece-count">{pieces.length}</p>
          <p className="text-xs text-[#5A5F6E]">from {sourceCount} old bundle{sourceCount === 1 ? '' : 's'}</p>
        </div>
      </div>
      {pieces.length === 0 ? (
        <p className="text-sm text-[#5A5F6E] py-6 text-center" data-testid="fc-pieces-empty">No pieces scanned yet.</p>
      ) : (
        <ul className="divide-y divide-[#EFE9DC] max-h-80 overflow-y-auto">
          {pieces.map((p) => (
            <li key={p.usn_code} className="flex items-center gap-3 py-2" data-testid={`fc-piece-${p.usn_code}`}>
              <div className="flex-1 min-w-0">
                <p className="font-mono text-sm font-medium">{p.usn_code}</p>
                <p className="text-xs text-[#5A5F6E] truncate">from {p.old_bundle_code}{p.pick_slip_no ? ` · ${p.pick_slip_no}` : ''}</p>
              </div>
              {p.label_printed && <Badge variant="outline" className="text-[10px] border-amber-300 text-amber-700">Label printed</Badge>}
              <button type="button" onClick={() => onRemove(p.usn_code)} className="p-1.5 rounded hover:bg-red-50 text-red-500 transition-colors"
                aria-label={`Remove ${p.usn_code}`} data-testid={`fc-piece-remove-${p.usn_code}`}>
                <X className="h-4 w-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
